// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__gMq1u","left":"InfoRow_left__2xHGY"};